import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import FormDrilldownList from "./FormDrilldownList.vue";
import { getAllValues } from "./utilities";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDrilldown',
    props: {
        id: null,
        value: { default: null },
        options: null,
        multiple: { type: Boolean, default: true }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const hasOptions = computed(() => {
            return props.options.length > 0;
        });
        // Determine all available values
        const allValues = computed(() => {
            return getAllValues(props.options);
        });
        // Determine current value
        const currentValue = computed(() => {
            if (props.value === null || props.value === "") {
                return [];
            }
            else if (Array.isArray(props.value)) {
                return props.value;
            }
            else {
                return [props.value];
            }
        });
        // Determine if select all is checked
        const selectAllChecked = computed(() => {
            return allValues.value.length === currentValue.value.length;
        });
        // Determine if select all state undetermined
        const selectAllIndeterminate = computed(() => {
            return ![0, allValues.value.length].includes(currentValue.value.length);
        });
        // Handle click on individual check/radio element
        function handleClick(value) {
            if (props.multiple) {
                const newValue = currentValue.value.slice();
                const index = newValue.indexOf(value);
                if (index !== -1) {
                    newValue.splice(index, 1);
                }
                else {
                    newValue.push(value);
                }
                if (newValue.length === 0) {
                    emit("input", null);
                }
                else {
                    emit("input", newValue);
                }
            }
            else {
                emit("input", value);
            }
        }
        // Handle click on select all checkbox to either select or unselect all values
        function onSelectAll(selected) {
            emit("input", selected ? allValues.value : null);
        }
        return { __sfc: true, props, emit, hasOptions, allValues, currentValue, selectAllChecked, selectAllIndeterminate, handleClick, onSelectAll, FormDrilldownList };
    }
});
